import { LayoutGrid, List, X } from 'lucide-react'
import { cn } from '@/utils/cn'
import { PAGE_TOOLBAR } from '@/components/ui/page-toolbar'
import type { JornadaViewMode } from '@/components/Gestores/gestorJornadaFilters'

type Props = {
  open: boolean
  onClose: () => void
  onClearAll: () => void
  view: JornadaViewMode
  setView: (v: JornadaViewMode) => void
}

export function GestorJornadaFiltersPanel({ open, onClose, onClearAll, view, setView }: Props) {
  if (!open) return null

  return (
    <>
      <div className='fixed inset-0 z-40 bg-black/40 md:hidden' aria-hidden onClick={onClose} />
      <div
        role='dialog'
        aria-label='Filtros da jornada'
        className={cn(
          'z-50 rounded-xl border border-[var(--glass-border)] bg-[var(--bg-card)] p-4 shadow-2xl',
          'fixed inset-x-4 bottom-4 max-h-[70vh] overflow-y-auto md:absolute md:inset-auto md:right-0 md:top-full md:mt-2 md:w-80',
        )}
      >
        <div className='mb-4 flex items-center justify-between'>
          <h3 className='text-sm font-semibold text-text-primary'>Filtros</h3>
          <button
            type='button'
            onClick={onClose}
            className='flex h-8 w-8 items-center justify-center rounded-lg text-text-muted hover:bg-white/[0.06] hover:text-text-primary'
            aria-label='Fechar filtros'
          >
            <X size={16} />
          </button>
        </div>

        <div className='space-y-4'>
          <div>
            <p className='mb-2 text-xs font-medium uppercase tracking-wide text-text-muted'>
              Visualização
            </p>
            <div className='grid grid-cols-2 gap-2'>
              {(
                [
                  { id: 'lista' as const, label: 'Lista', icon: List },
                  { id: 'cards' as const, label: 'Cards', icon: LayoutGrid },
                ] as const
              ).map(({ id, label, icon: Icon }) => (
                <button
                  key={id}
                  type='button'
                  onClick={() => setView(id)}
                  className={cn(
                    'flex min-h-[44px] items-center justify-center gap-2 rounded-xl border px-3 text-sm font-medium transition-colors',
                    view === id
                      ? 'border-accent/40 bg-accent/10 text-accent'
                      : 'border-[var(--glass-border)] text-text-secondary hover:text-text-primary',
                  )}
                >
                  <Icon size={15} />
                  {label}
                </button>
              ))}
            </div>
          </div>

          <button
            type='button'
            onClick={onClearAll}
            className={cn(PAGE_TOOLBAR.clearButton, 'w-full justify-center')}
          >
            Limpar filtros
          </button>
        </div>
      </div>
    </>
  )
}
